const position_isInWorld = (sizeX, sizeY) => (position) => position.x < sizeX && position.y < sizeY;
const position_isNotOrigin = (position) => !(position.x === 0 && position.y === 0);
const position_equalsNot = (pos1) => (pos2) => !(pos1.x === pos2.x && pos1.y === pos2.y);
export var Direction;
(function (Direction) {
    Direction["UP"] = "UP";
    Direction["RIGHT"] = "RIGHT";
    Direction["DOWN"] = "DOWN";
    Direction["LEFT"] = "LEFT";
})(Direction || (Direction = {}));
export function direction_rotationDegrees(direction) {
    if (direction === Direction.UP) {
        return 270;
    }
    if (direction === Direction.RIGHT) {
        return 0;
    }
    if (direction === Direction.DOWN) {
        return 90;
    }
    if (direction === Direction.LEFT) {
        return 180;
    }
}
export const initialWorld = {
    sizeX: 6,
    sizeY: 6,
    kara: {
        position: { x: 1, y: 1 },
        direction: Direction.RIGHT,
    },
    trees: [],
    leaves: [],
    mushrooms: [],
};
export function world_setKaraPosition(world, pos) {
    // Falls sich ein Pilz oder ein Baum auf pos befindet: Entfernen
    const mushroomsNew = world.mushrooms.filter(position_equalsNot(pos));
    const treesNew = world.trees.filter(position_equalsNot(pos));
    return Object.assign(Object.assign({}, world), { kara: Object.assign(Object.assign({}, world.kara), { position: pos }), mushrooms: mushroomsNew, trees: treesNew });
}
export function world_deleteEverythingFromField(world, pos) {
    return Object.assign(Object.assign({}, world), { trees: world.trees.filter(position_equalsNot(pos)), leaves: world.leaves.filter(position_equalsNot(pos)), mushrooms: world.mushrooms.filter(position_equalsNot(pos)) });
}
export function world_fieldHasLeaf(world, pos) {
    const found = world.leaves.find(posOfTree => posOfTree.x === pos.x && posOfTree.y === pos.y);
    if (found !== null && found !== undefined) {
        return true;
    }
    else {
        return false;
    }
}
export function world_fieldHasMushroom(world, pos) {
    const found = world.mushrooms.find(posOfTree => posOfTree.x === pos.x && posOfTree.y === pos.y);
    if (found !== null && found !== undefined) {
        return true;
    }
    else {
        return false;
    }
}
export function world_fieldHasTree(world, pos) {
    const found = world.trees.find(posOfTree => posOfTree.x === pos.x && posOfTree.y === pos.y);
    if (found !== null && found !== undefined) {
        return true;
    }
    else {
        return false;
    }
}
export function world_toggleLeaf(world, pos) {
    if (world_fieldHasLeaf(world, pos)) {
        // Blatt entfernen
        const newLeaves = world.leaves.filter(leafPos => !(leafPos.x === pos.x && leafPos.y === pos.y));
        return Object.assign(Object.assign({}, world), { leaves: newLeaves });
    }
    else {
        // Blatt hinzufügen
        const newLeaves = [...world.leaves, pos];
        // Falls ein Baum auf dieser Position ist: entfernen
        const newTrees = world.trees.filter(position_equalsNot(pos));
        return Object.assign(Object.assign({}, world), { leaves: newLeaves, trees: newTrees });
    }
}
export function world_toggleMushroom(world, pos) {
    if (position_equalsNot(world.kara.position)(pos)) {
        // Kara sitzt nicht auf pos
        if (world_fieldHasMushroom(world, pos)) {
            // Pilz entfernen
            const newMushrooms = world.mushrooms.filter(mushroomPos => !(mushroomPos.x === pos.x && mushroomPos.y === pos.y));
            return Object.assign(Object.assign({}, world), { mushrooms: newMushrooms });
        }
        else {
            // Pilz hinzufügen
            const newMushrooms = [...world.mushrooms, pos];
            // Falls ein Baum auf dieser Position ist: entfernen
            const newTrees = world.trees.filter(position_equalsNot(pos));
            return Object.assign(Object.assign({}, world), { mushrooms: newMushrooms, trees: newTrees });
        }
    }
    else {
        return world;
    }
}
export function world_toggleTree(world, pos) {
    if (position_equalsNot(world.kara.position)(pos)) {
        // Kara sitzt nicht auf pos
        if (world_fieldHasTree(world, pos)) {
            // Baum entfernen
            const newTreeArray = world.trees.filter(treePos => !(treePos.x === pos.x && treePos.y === pos.y));
            return Object.assign(Object.assign({}, world), { trees: newTreeArray });
        }
        else {
            // Baum hinzufügen
            const newTreeArray = [...world.trees, pos];
            // Falls ein Pilz oder ein Blatt auf pos sitzt: entfernen
            const newLeaves = world.leaves.filter(position_equalsNot(pos));
            const newMushrooms = world.mushrooms.filter(position_equalsNot(pos));
            return Object.assign(Object.assign({}, world), { trees: newTreeArray, leaves: newLeaves, mushrooms: newMushrooms });
        }
    }
    else {
        return world;
    }
}
